import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { FacilityCategoryNote, fetchAllNotes } from "src/api/facility";
import { LONG_STALE_TIME } from "src/constants/query";

interface UseFacilityNotesOptions {
  onDataChanged: (facilityNotes: FacilityCategoryNote[]) => void;
}
export function useFacilityNotes(workplaceId: string, { onDataChanged }: UseFacilityNotesOptions) {
  const queryClient = useQueryClient();
  const queryKey = ["facility-notes", workplaceId];

  const { isLoading: facilityNotesLoading, data: facilityNotes } = useQuery({
    queryKey,
    queryFn: () => {
      return fetchAllNotes(workplaceId);
    },
    staleTime: LONG_STALE_TIME,
  });

  useEffect(() => {
    if (facilityNotes) {
      onDataChanged(facilityNotes);
    }
  }, [facilityNotes, onDataChanged]);

  const invalidateCache = () => {
    queryClient.removeQueries(queryKey);
  };

  const updateFacilityNotes = (updatedFacilityNotes: FacilityCategoryNote[]) => {
    queryClient.setQueryData(queryKey, updatedFacilityNotes);
  };

  return {
    data: facilityNotes ?? [],
    isLoading: facilityNotesLoading,
    invalidateCache,
    updateFacilityNotes,
  };
}
